import { Availability, AvailabilityService, CreateAvailability } from '@services';
import { message } from 'antd';
import { makeAutoObservable, runInAction } from 'mobx';

class AvailabilityStore {
  workAvailabilities = new Map<string, Availability>();
  dropoffAvailabilities = new Map<string, Availability>();
  loading: boolean = false;
  workAvailabilitiesRequest: Promise<void> | undefined;

  constructor() {
    makeAutoObservable(this, { workAvailabilitiesRequest: false });
  }

  getWorkAvailabilities = async () => {
    // the schedule is tenant wide, so concurrent callers share a single request
    if (this.workAvailabilitiesRequest) {
      return this.workAvailabilitiesRequest;
    }

    this.setLoading(true);
    this.workAvailabilitiesRequest = (async () => {
      try {
        const result = await AvailabilityService.getAvailabilities({ type: 'work' });
        runInAction(() => {
          this.workAvailabilities.clear();
          result.forEach((item) => {
            this.workAvailabilities.set(item.id, item);
          });
        });
      } catch (error) {
        console.error('Error fetching availability:', error);
      } finally {
        this.setLoading(false);
        this.workAvailabilitiesRequest = undefined;
      }
    })();

    return this.workAvailabilitiesRequest;
  };

  getDropoffAvailabilities = async () => {
    this.setLoading(true);
    try {
      const result = await AvailabilityService.getAvailabilities({ type: 'dropoff' });
      result.forEach((item) => {
        this.dropoffAvailabilities.set(item.id, item);
      });
    } catch (error) {
      console.error('Error fetching availability:', error);
    } finally {
      this.setLoading(false);
    }
  };

  createOrUpdate = async (input: CreateAvailability[]) => {
    this.setLoading(true);
    try {
      await AvailabilityService.createOrUpdate(input);
      // keep cached working hours in sync for everything that derives from them
      await this.getWorkAvailabilities();
      message.success({
        content: 'Successfully updated!',
      });
    } catch (error) {
      console.error('Error creating availability:', error);
    } finally {
      this.setLoading(false);
    }
  };

  setLoading = (value: boolean) => {
    runInAction(() => {
      this.loading = value;
    });
  };

  clearWorkAvailabilities = () => {
    runInAction(() => {
      this.workAvailabilities.clear();
    });
  };
  clearDropoffAvailabilities = () => {
    runInAction(() => {
      this.dropoffAvailabilities.clear();
    });
  };
}

export default AvailabilityStore;
